<div #googleSignInButton
     id="g_id_signin">
</div>
